import { bootstrapApplication } from '@angular/platform-browser';
import { sanaTherapistAppConfig } from './app/app.config';
import { AppComponent } from './app/app.component';

bootstrapApplication(AppComponent, sanaTherapistAppConfig)
  .catch((err) => console.error(err));
